import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/_app/subjects/$id/report")({
  validateSearch: (search) => {
    return z
      .object({
        reportId: z.coerce.number().optional(),
      })
      .parse(search);
  },
});
